/* eslint-disable prefer-rest-params, no-param-reassign */
;(function initGoogleAnalytics(w, d, s, id) {
    w.dataLayer = w.dataLayer || []
    function gtag() {
        w.dataLayer.push(arguments)
    }
    w.gtag = gtag
    gtag('js', new Date())
    gtag('config', id, { send_page_view: false })

    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement(s)
    j.async = true
    j.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
    f.parentNode.insertBefore(j, f)
})(window, document, 'script', 'G-3S7RRVNVDJ')
